<template>
  <b-navbar type="is-primary">
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <b-icon icon="futbol" pack="fas" size="is-medium" type="is-white"></b-icon>
      </b-navbar-item>
    </template>

    <template slot="start">
      <b-navbar-item href="/">
        Futsal Met
      </b-navbar-item>
    </template>

    <template v-if="isLogin" slot="end">
      <b-navbar-item tag="div">
        <a href="/events/create" title="イベント作成">
          <b-icon icon="plus-circle" pack="mdi" size="is-medium" type="is-light"></b-icon>
        </a>
      </b-navbar-item>
      <b-navbar-item tag="div">
        <figure class="image is-32x32">
          <img class="is-rounded" :src="currentUser.photoURL">
        </figure>
        <span>{{currentUser.displayName}}</span>
      </b-navbar-item>
      <b-navbar-item tag="div">
        <div class="buttons">
          <a class="button is-light" @click="signoutButtonPressed">ログアウト</a>
        </div>
      </b-navbar-item>
    </template>
    <template v-else slot="end">
      <b-navbar-item tag="div">
        <a href="/events/create" title="イベント作成">
          <b-icon icon="plus-circle" pack="mdi" size="is-medium" type="is-light"></b-icon>
        </a>
      </b-navbar-item>
      <b-navbar-item tag="div">
        <div class="buttons">
          <b-dropdown position="is-bottom-left" aria-role="list" trap-focus>
            <button class="button is-light" slot="trigger">
              <span>ログイン</span>
              <b-icon icon="menu-down"></b-icon>
            </button>
            <b-dropdown-item
              aria-role="menu-item"
              :focusable="false"
              custom
              >
              <div class="modal-card" style="width:200px;">
                <login></login>
              </div>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
import firebase from '@/firebase/firebase'
import Login from "@/components/Login.vue";

export default {
  name: 'navbar',
  props: ['currentUser', 'isLogin'],
  components: {
    Login
  },
  data() {
    return {
    }
  },
  methods: {
    signoutButtonPressed(e) {
      e.stopPropagation();
      firebase.auth().signOut();
    }
  }
};
</script>

<style>
</style>
